export const SUCCESS = `Thank you.\n\nYou'll receive an email with next steps if your address is in our system.`;
export const INVALID_EMAIL = "Please enter a valid email address.";
export const MISSING_PASSWORD = "Please enter your password";
export const BAD_LOGIN = `Invalid Login.\n\nPlease check your e-mail and password and try again.\n\nIf you continue having trouble please ***INSTRUCTIONS***.`;
/** Verbatim message from AccountService.CreateUserAsync when the address is taken. */
export const EMAIL_ALREADY_REGISTERED = "Email already registered";
